import { Alert, FormCheck, FormControl, Modal } from "react-bootstrap";
import { useState } from "react";
import { Button } from "react-bootstrap";
import PropTypes, { object } from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalRecetaRetenida from "./ModalRecetaRetenida"
import cogoToast from "cogo-toast";
import clsx from "clsx";
import { setPacienteSeleccionado } from "../../store/slices/paciente-slice";

import { useRut, isValid, unformat, format, } from 'react-rut';
import calcularDigitoVerificador from "../../helpers/rut";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addToCart } from "../../store/slices/cart-slice";
import { Dropdown, DropdownButton, Spinner, Form } from "react-bootstrap";

//importa flecha hacia abajo desde fortawesome/free-solid-svg-icons
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ModalPaciente from "./ModalPaciente"
import ModalCuenta from "./ModalCuenta";
import ModalidadModal from "../../components/modalidad/modalidadModal";
import { getDescuentoPaciente } from "../../firebase/firebase-functions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBeneficiario, getConsultaProducto } from "../../yapp/yapp-methods";
import { set } from "react-ga";

const ModalSeleccion = ({ showModalSeleccion, handleCloseModalSeleccion, objMedicamento }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { cartItems } = useSelector((state) => state.cart);
    const { arrPacientes } = useSelector((state) => state.paciente);
    const { pacienteSeleccionado } = useSelector((state) => state.paciente)
    const { modalidadSeleccionada } = useSelector((state) => state.modalidad)
    const { user } = useSelector((state) => state.user)

    const [cantidadEnCarro, setCantidadEnCarro] = useState(0)
    const [cantidad, setCantidad] = useState(1);

    const [recetaVisible, setRecetaVisible] = useState(false);

    const [solicitaRetiro, setSolicitaRetiro] = useState(false);

    const handleCloseReceta = () => setRecetaVisible(false)

    const [arrPacientesSinSeleccionado, setArrPacientesSinSeleccionado] = useState([])
    const cantidadMaximaAComprar = 6;
    //funcion que revisa cual es la cantidad actual del producto en el carro a traves de la propiedad id
    const revisaCantidadEnCarro = () => {
        //console.log("revisaCantidadEnCarro")
        //console.log(cartItems)
        const cantidadEnCarro = cartItems.find(item => item.id === objMedicamento.kinf2);
        //console.log(cantidadEnCarro)
        if (cantidadEnCarro) {
            //console.log("cantidadEnCarro.quantity")
            //console.log(cantidadEnCarro.cantidad)
            //console.log("existe en carro")
            //console.log(objMedicamento)
            setCantidadEnCarro(cantidadEnCarro.cantidad)
            if (objMedicamento.stock <= cantidadEnCarro.cantidad) {
                setCantidad(0)
            }

        } else {
            //console.log("no existe en carro")
            setCantidadEnCarro(0)
        }
    }
    var selector;
    const handleClick = e => {
        selector = e.currentTarget.nextSibling.classList
        selector.toggle("active");
    };
    const triggerMobileMenu = () => {
        const offcanvasMobileMenu = document.querySelector(
            "#offcanvas-mobile-menu"
        );
        offcanvasMobileMenu.classList.add("active");
    };
    useEffect(() => {
        //console.log("cantidad: " + cantidad);
        //console.log(objMedicamento)
        //quita el paciente seleccionado del array de pacientes y almacena el resultado en el array sin seleccionado

        revisaCantidadEnCarro();
        return () => {
            //console.log("cleaned up")
        };
    }, [cantidad])

    useEffect(() => {
        //console.log(arrPacientes)
        //console.log(pacienteSeleccionado)
        //console.log(format(pacienteSeleccionado.rut + calcularDigitoVerificador(pacienteSeleccionado.rut)))
        //console.log("array pacientes")
        //console.log(arrPacientes)

        let arrTemp = arrPacientes.filter(paciente => paciente.rut !== pacienteSeleccionado.rut)
        //console.log("arrTemp")
        //console.log(arrTemp)
        if (arrTemp.length === 0) {
            setArrPacientesSinSeleccionado([])
        }
        else {
            setArrPacientesSinSeleccionado(arrTemp)
        }

        return;
    }, [arrPacientes, pacienteSeleccionado])

    const [precioFinal, setPrecioFinal] = useState(objMedicamento.precio)
    const [loadingPrecioFinal, setLoadingPrecioFinal] = useState(true)
    const [descuentoSocial, setDescuentoSocial] = useState(0)


    //state para utilizar seguro
    const [puedeUtilizarSeguro, setPuedeUtilizarSeguro] = useState(false);

    const [utilizaSeguro, setUtilizaSeguro] = useState(false);

    //state para cobertura
    const [tieneCoberturaSeguro, setTieneCoberturaSeguro] = useState(false);

    //state para buscar descuento liga
    const [utilizaDsctoLiga, setUtilizaDsctoLiga] = useState(true);


    // useEffect(() => {
    //     const getSeguro = async () => {
    //         console.log("busco seguro");
    //         let rutSeguro = pacienteSeleccionado.rut + '-' + calcularDigitoVerificador(pacienteSeleccionado.rut)
    //         console.log(rutSeguro);
    //         try {
    //             if (!pacienteSeleccionado.rut) {
    //                 console.log("sin rut valido");
    //                 setUtilizaDsctoLiga(true)
    //                 setUtilizaSeguro(false)
    //                 setPuedeUtilizarSeguro(false)
    //                 return;
    //             }
    //             const response = await getBeneficiario(rutSeguro)
    //             console.log(response);
    //             if (response.datos) {
    //                 console.log("puede usar seguro");
    //                 setPuedeUtilizarSeguro(true)
    //                 setUtilizaDsctoLiga(true)
    //             }
    //             else {
    //                 console.log("no puede usar seguro, usa dscto liga");
    //                 setPuedeUtilizarSeguro(false)
    //                 setUtilizaSeguro(false)
    //                 setUtilizaDsctoLiga(true)
    //             }

    //         } catch (error) {
    //             console.log(error);
    //         }
    //     }
    //     console.log("useeffect paciente seleccionado");
    //     getSeguro()
    //     return () => {
    //         //console.log("cleaned up paciente seleccionado")
    //     };
    // }, [pacienteSeleccionado])

    useEffect(() => {
        const getDescuento = async () => {
            setLoadingPrecioFinal(true)

            try {

                let obj = {
                    rutp: pacienteSeleccionado.rut.padStart(8, "0"),
                    kinf: objMedicamento.kinf,
                    trec: 'RCC',
                    pres: objMedicamento.pres,
                    ksuc: modalidadSeleccionada.codigo,
                }
                //console.log(obj)
                console.log("busco descuento social");
                await getDescuentoPaciente(obj).then((response) => {
                    console.log(response)
                    //console.log("precio normal: " + objMedicamento.precio)
                    //console.log("precio final: " + Math.floor(objMedicamento.precio - (response.descuentoPac / 100) * objMedicamento.precio))

                    if (response.descuentoPac) {
                        //console.log("descuento social ok")
                        //console.log(response.descuentoPac)
                        setDescuentoSocial(response.descuentoPac)
                        //console.log(response.descuentoPac)
                        setPrecioFinal(Math.floor(objMedicamento.precio - (response.descuentoPac / 100) * objMedicamento.precio))
                    }
                    else {
                        //console.log("descuento pac con error")
                        //setDescuentoSocial(response.descuentoPac)
                        //console.log(response.descuentoPac)
                        setPrecioFinal(objMedicamento.precio)
                    }
                    setLoadingPrecioFinal(false)
                })
                    .catch((error) => {
                        //console.log(error)
                        setLoadingPrecioFinal(false)
                        setPrecioFinal(objMedicamento.precio)
                    })


            } catch (error) {
                setLoadingPrecioFinal(false)
                //console.log(error)
            }
        }
        //console.log(utilizaDsctoLiga);
        if (utilizaDsctoLiga) {
            getDescuento()
        }
        //getDescuento()

        return;
    }, [utilizaDsctoLiga, pacienteSeleccionado]);


    // useEffect(() => {
    //     const consultaProducto = async () => {
    //         console.log(objMedicamento.kinf);
    //         const response = await getConsultaProducto(objMedicamento.kinf)
    //         setLoadingPrecioFinal(false)
    //         if (response.obtenido) {
    //             console.log("cobertura obtenida");
    //             if (response.datos.cobertura) {
    //                 console.log("tiene cobertura");
    //                 return setTieneCoberturaSeguro(true)
    //             }
    //         }
    //         return setTieneCoberturaSeguro(false)
    //     }

    //     console.log("use effect utiliza seguro");
    //     if (utilizaSeguro) {
    //         console.log("consulto producto: " + objMedicamento.nombre_medicamento + " " + objMedicamento.kinf);
    //         consultaProducto()
    //     }

    //     return;
    // }, [utilizaSeguro]);

    const [nuevoPacienteVisible, setNuevoPacienteVisible] = useState(false)

    const handleNuevoPaciente = () => {
        //console.log("Nuevo paciente")
        setNuevoPacienteVisible(true)
        //console.log(nuevoPacienteVisible);
    }

    const hidePacienteModal = () => {
        setNuevoPacienteVisible(false)
    }



    const handleAgregaACarro = () => {
        if (utilizaSeguro) {
            //console.log("agregando al carro medicamento "+objMedicamento.nombre_medicamento+ " con seguro");
        }
        else {
            //console.log("agregando al carro medicamento "+objMedicamento.nombre_medicamento+ " sin seguro");
        }

        //console.log("bandera")
        //console.log(pacienteSeleccionado)
        //console.log(cartItems)
        //si no hay paciente seleccionado muestra un error
        if (!pacienteSeleccionado.rut) {
            cogoToast.error("Debe seleccionar un paciente para agregar al carro", { position: "top-center" });
            return;
        }

        if (objMedicamento.tipo_venta === "Receta Cheque") {

            //console.log("dispatch con cheque")
            dispatch(addToCart({ medicamento: objMedicamento, cantidad: cantidad, paciente: pacienteSeleccionado, precioFinal: precioFinal, descuentoPac: descuentoSocial, retiroReceta: solicitaRetiro, utilizaSeguro: utilizaSeguro }))

        }
        else {
            dispatch(addToCart({ medicamento: objMedicamento, cantidad: cantidad, paciente: pacienteSeleccionado, precioFinal: precioFinal, descuentoPac: descuentoSocial, utilizaSeguro: utilizaSeguro }))

        }

        productoAgregado(objMedicamento)
        //console.log("producto visible")
        handleCloseModalSeleccion();
    }

    const productoAgregado = (medicamento) => {
        const { hide } = cogoToast.success(
            <div className=" text-center justify-content-center align-items-center d-flex pt-3 pb-3">
                <button className="boton p-2 m-2 col-6" onClick={() => {
                    hide()
                }}
                    style={{ width: "120px" }} >{"Continuar"}</button>
                <button
                    className="boton p-2 m-2 col-6"
                    onClick={() => {
                        hide()
                        navigate("/recetas")
                    }}
                >{"Ir al carro"}</button>
            </div>,
            {
                position: "top-center",
                heading: medicamento.nombre_medicamento + " agregado con exito",
                hideAfter: 5,
            }
        );
    }


    const [showModalCuenta, setShowModalCuenta] = useState(false);

    //usestate para mostrar modal de modalidad
    const [modalidadVisible, setModalidadVisible] = useState(false);

    useEffect(() => {
        if (!user) {
            setShowModalCuenta(true);

        }
        else {
            setShowModalCuenta(false);
        }

    }, [])

    useEffect(() => {
        //reviso logica para setear modalidadVisible
        //setModalidadVisible(true);
        console.log("pinto modalidad seleccionada: " + modalidadSeleccionada.nombre);
        try {
            console.log("entro a try");
            console.log(modalidadSeleccionada);
            console.log("date.day: " + new Date().getDay());
            if (modalidadSeleccionada.fecha_seleccion !== new Date().getDay()) {
                console.log("cambiar modalidad");
                console.log("modalidad seleccionada con fecha: " + modalidadSeleccionada.seleccionada);
                 setModalidadVisible(true);
            }
            else {
                console.log("no selecciono modalidad");
            }
        } catch (error) {

            console.log(error);

        }

    }, [modalidadSeleccionada]);

    return (
        <Modal show={showModalSeleccion} onHide={handleCloseModalSeleccion}
            className="seleccion"
        >


            <Modal.Header closeButton>
                <Modal.Title className="titulo" >Seleccionar cantidad y objetivo de compra</Modal.Title>
            </Modal.Header>
            <Modal.Body >



                {showModalCuenta ?

                    <ModalCuenta

                        showModalCuenta={showModalCuenta}
                        handleClose={() => setShowModalCuenta(false)}
                    /> : null}
                {modalidadVisible ?
                    <ModalidadModal
                        showModalidad={modalidadVisible}
                        onHideModalidad={() => setModalidadVisible(false)}
                    />
                    : null}

                <div className="col-12 seleccion ml-6"

                >
                    <div className="row">
                        <div className="col-8">
                            <ModalPaciente
                                showPacienteModal={nuevoPacienteVisible}
                                onHidePacienteModal={() => hidePacienteModal()}
                            />
                            <p className="seleccion">Comprando medicamento:</p>

                            <p className="fw-bold">{objMedicamento.nombre_medicamento}<span>{" ("}{objMedicamento.contenido}{")"}</span></p>
                            {objMedicamento.pap_maestro ?
                                <div>
                                    <p id="bonificacion-seleccion"><span> {"Por la compra de "}{objMedicamento.pap.descripcion[0]} {objMedicamento.pap.descripcion[0] > 1 ? " cajas, " : " caja, "} {"recibes "} {objMedicamento.pap.descripcion[4]} {" caja sin costo"}</span></p>
                                </div>
                                : null}
                            {
                                loadingPrecioFinal ?
                                    <p>{"Precio: "}<Spinner animation="border" role="status" size="sm" /></p>
                                    :
                                    objMedicamento.precio != precioFinal ?
                                        <div><p>{"Precio: "}<span className="fw-bold" style={{ textDecoration: "line-through" }}>{"$" + objMedicamento.precio.toLocaleString("es-CL")}</span> <span className="fw-bold precio-final">{"$" + precioFinal.toLocaleString("es-CL")}</span></p>
                                            <Alert variant="success" className="pt-1 pb-1 ps-2 pe-2">{"Se ha aplicado el descuento social de: "}{descuentoSocial}{"%"}</Alert>
                                        </div>
                                        :
                                        <p>{"Precio: "}<span className="fw-bold" >{"$" + objMedicamento.precio.toLocaleString("es-CL")}</span></p>
                            }

                        </div>
                        <div className="col-4">
                            <img src={objMedicamento.image[0]} alt=""
                                width={"100px"}
                            />

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 dropdown-custom seleccion">
                            <p>Para paciente:</p>

                            <DropdownButton id="dropdown-basic-button" title={pacienteSeleccionado.nombre ? format(pacienteSeleccionado.rut + (calcularDigitoVerificador(pacienteSeleccionado.rut) === '11' ? 0 : calcularDigitoVerificador(pacienteSeleccionado.rut))) + " / " + pacienteSeleccionado.nombre + " " + pacienteSeleccionado.apellidos + " " : "Seleccione paciente " + " "} className="col-12 dropdown-custom">
                                {
                                    arrPacientesSinSeleccionado.length === 0 || arrPacientes === undefined ? null :

                                        arrPacientesSinSeleccionado.map((paciente, index) => (
                                            <Dropdown.Item

                                                key={index}>
                                                <Link
                                                    className="fs-6 text-end"
                                                    onClick={() => {

                                                        dispatch(setPacienteSeleccionado(paciente))

                                                    }}>
                                                    {format(paciente.rut + (calcularDigitoVerificador(paciente.rut) === '11' ? 0 : calcularDigitoVerificador(paciente.rut))) + " / " + paciente.nombre + " " + paciente.apellidos}

                                                </Link>
                                            </Dropdown.Item>
                                        ))

                                }
                                <Dropdown.Item
                                    onClick={() =>
                                        handleNuevoPaciente()
                                    }
                                >
                                    {"Agregar un nuevo paciente"}
                                </Dropdown.Item>
                            </DropdownButton>
                        </div>

                    </div>

                    <div className=" pro-details-quality row">
                        {/* <div className="col-12 text-center">

                            <p className="pt-2 pb-0 mb-1">{"¿Compras para otro paciente?"}</p>
                            <Link className="pt-1 " onClick={() => handleNuevoPaciente()}>{" Haz click aquí para agregarlo"}</Link>
                        </div> */}
                        <div className="col-12 pt-3">
                            {
                                loadingPrecioFinal ?
                                    <p>{"Subtotal: "}<Spinner animation="border" role="status" size="sm" /></p>
                                    :
                                    objMedicamento.precio != precioFinal ?
                                        <p>{"Subtotal: "}<span className="fw-bold" style={{ textDecoration: "line-through" }}>{"$" + (cantidad * objMedicamento.precio).toLocaleString("es-CL")}</span> <span className="fw-bold precio-final">{"$" + (cantidad * precioFinal).toLocaleString("es-CL")}</span></p>
                                        :
                                        <p>{"Subtotal: "}<span className="fw-bold">{"$" + (cantidad * objMedicamento.precio).toLocaleString("es-CL")}</span></p>
                            }

                            {
                                utilizaSeguro && tieneCoberturaSeguro ?
                                    <div>
                                        <p style={{ fontSize: '13px', lineHeight: 'normal', paddingBottom: '10px' }} >{"*Medicamento con cobertura de seguro."}</p>
                                    </div>
                                    : null
                            }

                            {/* {
                                puedeUtilizarSeguro && !utilizaSeguro ?
                                    <div
                                        style={{
                                            border: 'solid',
                                            borderColor: '#e58f2f',
                                            borderRadius: 10,
                                            textAlign: 'center',
                                            marginBottom: 15,
                                            paddingInline: 5
                                        }}
                                    >
                                        <p style={{fontSize: '13px', lineHeight: 'normal', paddingBlock: '10px' }} >
                                            {"*Se ha detectado un seguro médico"}
                                            <button
                                                className="boton"
                                                style={{ fontSize: 12, margin: 8 }}
                                                onClick={()=> {
                                                    console.log("mas información");
                                                    if(puedeUtilizarSeguro){
                                                        const { hide } = cogoToast.success(
                                                            <div className=" text-center justify-content-center align-items-center d-flex pt-3 pb-3">
                                                                <button className="boton p-2 m-2 col-6" onClick={() => {
                                            
                                            
                                                                    setUtilizaSeguro(false)
                                                                    setUtilizaDsctoLiga(true)
                                                                    hide()
                                                                }}
                                                                    style={{ width: "120px" }} >{"No"}</button>
                                                                <button
                                                                    className="boton p-2 m-2 col-6"
                                                                    onClick={() => {
                                                                        console.log("usa seguro");
                                                                        setUtilizaSeguro(true)
                                                                        setUtilizaDsctoLiga(false)
                                                                        hide()
                                                                    }}
                                                                >{"Utilizar seguro"}</button>
                                                            </div>,
                                                            {
                                                                position: "top-center",
                                                                heading: <div>{"Se ha detectado un seguro médico, ¿Deseas utilizarlo?"}
                                                                    <p style={{ color: 'black', paddingTop: "10px", lineHeight: 'normal' }}>{"* El precio final a pagar se verá reflejado en la pantalla de pago"}</p>
                                                                </div>, //"Se ha detectado un seguro médico, ¿Deseas utilizarlo?",
                                                                hideAfter: 0,
                                                            }
                                                        );
                                                    }
                                                    
                                                    return;
                                                }}
                                            >{"Mas información"}
                                            </button>
                                        </p>
                                    </div>
                                    : null
                            } */}

                            {/* {
                                puedeUtilizarSeguro && utilizaSeguro ?
                                <div
                                style={{
                                    border: 'solid',
                                    borderColor: 'green',
                                    borderRadius: 10,
                                    textAlign: 'center',
                                    marginBottom: 15,
                                    paddingInline: 5
                                }}
                            >
                                <p style={{fontSize: '13px', lineHeight: 'normal', paddingBlock: '10px' }} >
                                    {"Estas utilizando un seguro médico, el valor final se verá reflejado en la pantalla de pago"}
                                    <button
                                                className="boton"
                                                style={{ fontSize: 12, margin: 8 }}
                                                onClick={()=> {
                                                    console.log("mas información");
                                                    setUtilizaSeguro(false)
                                                    setUtilizaDsctoLiga(true)
                                                }
                                            }
                                >No utilizar</button>
                                    </p>
                                    </div>

                                    : null
                            } */}
                        </div>
                        {/* {
                            objMedicamento.id_conXXXXd_venta === 2 && objMedicamento.tipo_controlado === "BEN" ?
                                <div>
                                    <Alert variant="warning">{"Para los medicamentos COMPLETAR debes indicar si debemos ir a retirar la receta a tu domicilio o si es digitalizada."}
                                        <br />
                                        <div className="text-end pb-2">


                                            <ModalRecetaRetenida
                                                showReceta={recetaVisible}
                                                handleCloseReceta={handleCloseReceta}
                                            />


                                            <span>
                                                <strong style={{ cursor: 'pointer' }} onClick={() => setRecetaVisible(true)}><i className="fa fa-info-circle"></i>{"¿Que es esto?"}</strong>

                                            </span>
                                        </div>


                                        <Form>
                                            <Form.Check
                                                type={'radio'}
                                                checked={solicitaRetiro ? true : false}
                                                id="radio1"
                                                onChange={()=>setSolicitaRetiro(true)}
                                                label={
                                                    <>
                                                        {"Tengo una receta cheque (física)"}
                                                        <br />
                                                        {"(Retiro de receta: + $3990)"}
                                                    </>
                                                } />
                                            <Form.Check
                                                type={'radio'}
                                                id="radio2"
                                                checked={!solicitaRetiro ? true : false}
                                                onChange={()=>setSolicitaRetiro(false)}
                                                label={
                                                    <>
                                                    {"Mi receta es electrónica o digitalizada."}
                                                    </>
                                                    
                                                    } />
                                        </Form>
                                    </Alert>

                                </div>
                                : null
                        } */}

                        <div className="row col-12 justify-content-center product-quantity m-2">
                            <div className="cart-plus-minus col-4">
                                <button
                                    onClick={() =>
                                        setCantidad(cantidad > 1 ? cantidad - 1 : 1)
                                    }
                                    className="dec qtybutton"
                                    disabled={cantidad === 0 ? true : false}
                                >
                                    -
                                </button>
                                <input
                                    className="cart-plus-minus-box"
                                    type="text"
                                    value={cantidad}
                                    readOnly
                                />

                                <button
                                    onClick={() =>
                                        // setCantidad(
                                        //     //si la cantidad es menor que el stock menos la cantidad en el carro
                                        //     cantidad < objMedicamento.stock  - cantidadEnCarro

                                        //         ? cantidad + 1
                                        //         : cantidad
                                        // )
                                        setCantidad(
                                            //si la cantidad es menor que el stock menos la cantidad en el carro
                                            cantidad >= objMedicamento.stock - cantidadEnCarro || cantidad >= cantidadMaximaAComprar

                                                ? cantidad
                                                : cantidad + 1
                                        )
                                    }
                                    className="inc qtybutton"
                                    disabled={cantidad === 0 ? true : false}
                                >
                                    +
                                </button>
                            </div>


                            <div className="pro-details-cart  col-8 text-center">
                                <button className={cantidad === 0 ? "btn-disabled ps-3 pe-3" : "boton p-2 ps-3 pe-3 "}
                                    disabled={cantidad === 0 || loadingPrecioFinal ? true : false}
                                    onClick={handleAgregaACarro}>{cantidad === 0 ? "Sin stock disponible" : "Añadir al carro"}</button>
                            </div>
                        </div>
                        {objMedicamento.pap_maestro && cantidad >= (objMedicamento.pap.requerido / objMedicamento.pres) ?

                            <div>
                                <p id="bonificacion-seleccion">{"Recibirás " + Number.parseInt((cantidad * objMedicamento.pres) / objMedicamento.pap.requerido) + " caja(s) adicional sin costo"}</p>
                            </div>
                            :

                            null}
                        {
                            objMedicamento.stock <= cantidadEnCarro ?
                                <p>Stock maximo disponible agregado al carro</p> : null
                        }
                        {
                            cantidad >= cantidadMaximaAComprar ?
                                <p>Cantidad maxima disponible alcanzada</p> : null
                        }




                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>

            </Modal.Footer>
        </Modal>
    );
}

ModalSeleccion.propTypes = {
    showModalSeleccion: PropTypes.bool.isRequired,
    handleCloseModalSeleccion: PropTypes.func.isRequired,
    objMedicamento: PropTypes.object.isRequired
}

export default ModalSeleccion;